export const validateTaiwanPhone = (phone) => {
  if (typeof phone !== "string") return false;

  // Remove spaces and hyphens for uniformity
  const normalizedPhone = phone.replace(/[-\s]/g, "");

  // Mobile Number: 09XX-XXX-XXX (10 digits)
  const mobilePattern = /^09\d{8}$/;

  // Landline Number: Area Code (02-08) + 7~8 digits
  const landlinePattern = /^(0[2-8])\d{7,8}$/;

  // Toll-Free & Service Numbers: 0800 / 0809 + 6 digits
  const tollFreePattern = /^(0800|0809)\d{6}$/;

  // Validate against patterns
  return (
    mobilePattern.test(normalizedPhone) ||
    landlinePattern.test(normalizedPhone) ||
    tollFreePattern.test(normalizedPhone)
  );
}